import React from 'react';
import './Scroll.css';

export const Scroll = () => {
    return (
        // <a href='#home' class="scroll-down">
        //     <div class="scroll-down-text">SCROLL DOWN</div>
        //     <div class="scroll-down-bar"></div>
        // </a>

        <div class="mouse"></div>
    )
}
